/**
 * Order Logs
 */

// React
import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import { getLogsAction, getOrderWithIdAction } from '../orders/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import { makeSelectLogs, makeSelectOrder } from '../orders/selectors';

//UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Typography, Paper, Button, Grid, Divider } from '@material-ui/core';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Helper
import { translate, formaterPhoneNumber } from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import Can from '../../components/Can';

// Type
import { Log } from '../orders/interfaces';
import { SelectorProps, Props } from './interfaces';
import RonadIcons from '../../components/iconComponent';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondaryTail: {
      backgroundColor: theme.palette.secondary.main,
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    headerBox: {
      display: 'flex',

      alignItems: 'center',
      marginBottom: '28px',
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: theme.spacing(4),
      marginBottom: '36px',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      border: '1px solid #ddd',
      borderRadius: '4px 4px 0 0',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    divider: {
      width: '97%',
      margin: '0 auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  })
);

//const
const iconStatus = {
  ARRIVED: "mapMarker", //'به مقصد رسیده',
  BUNDLED: "packageVariantClosed", //' بسته‌بندی شده برای راننده',
  CANCELLED: "times", //'لغو شده',
  DELIVERED_TO_POST: "circleMedium", //'ارسال شده',
  DELIVERED_TO_CENTER: "circleMedium", //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: "circleMedium", //'تامین در مرکز',
  PACKAGED: "cubeOutline", //'بسته‌بندی شده برای مشتری',
  DELIVERED: "listCheck", //'تحویل داده شده',
  LOADED: "truck", // 'در حال تحویل',
  NOT_DELIVERED: "information", //'تحویل داده نشده',
  ORDERED: "circleMedium", //'ایجاد شده',
  RETURNED: "undo", //'بازگردانده شده',
  PICKED: "plusMultiple", //'برداشته شده',
  ASSIGNED: "userArrowRight", //'برداشته شده',
  DELIVERING_TO_POST: 'circleMedium',
  DELIVERED_TO_COURIER: 'circleMedium',
  PROCESSING: 'circleMedium',
  PROCESSED: 'circleMedium',
  REGISTERED_IN_3PL: 'circleMedium',
  REGISTERING_IN_3PL: 'circleMedium',
  DELIVERING: 'circleMedium',
  DELIVERED_TO_3PL: 'circleMedium',
  DELIVERED_TO_3PL_COURIER: 'circleMedium',
  CANCELED_FROM_3PL: 'circleMedium',
  AWAITING_REVIEW: 'circleMedium',
  SUPPLYING: 'circleMedium',
  REQUESTED_TO_RETURN: 'circleMedium',
  RETURNED_TO_WAREHOUSE: 'circleMedium',
  REQUESTED_TO_RESEND: 'circleMedium',
  SCANNED: 'circleMedium',
  CONFIRMED: 'circleMedium',
  REGISTERED: 'circleMedium',
  AWAITING_PAYMENT: 'circleMedium',
  CANCELED: 'times',
};
const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته‌بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

export function Logs(props: Props) {
  const authContext = useContext(AuthContext);

  const classes = useStyles();

  useEffect(() => {
    const { id } = props.match.params;
    props.getLogsDispatch(id);
    props.orderWithIdActionDispatch(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <div className={classes.headerBox}>
        <Typography
          variant="h6"
          component="div"
          style={{ marginLeft: '20px', fontSize: '18px' }}
        >
          {`تاریخچه سفارش`}
        </Typography>
        <span className={classes.contentlabelTitle} data-cy="orderId">
          {props.match.params?.id}
        </span>
      </div>
      <Button
        aria-label="details"
        size="medium"
        onClick={() => window.history.back()}
      >
        <RonadIcons name='chevronRight' size={1} className={classes.icon} />
        {`بازگشت`}
      </Button>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <RonadIcons name='user'
                  size={1}
                  className={classes.icon}
                />
                {`نام سفارش‌دهنده:  `}
              </span>

              <span data-cy="customerName">{props.order.customerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <RonadIcons name='callBack'
                  size={1}
                  className={classes.icon}
                />
                {`شماره همراه سفارش‌دهنده:  `}
              </span>
              <span data-cy="customerPhoneNumber">
                {formaterPhoneNumber(props.order.customerPhoneNumber)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <RonadIcons
                  name='calendar'
                  size={0.8}
                  className={classes.icon}
                />
                {`زمان تحویل:  `}
              </span>
              <span data-cy="deliveryDate">
                {props.order.deliveryDate &&
                  jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <RonadIcons name='packageVariant'
                  size={1}
                  className={classes.icon}
                />
                {`شناسه سفارش:  `}
              </span>
              <span data-cy="orderId">{props.order.id}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          {props.order.bundleId && (
            <Can
              role={authContext.user.role}
              perform="orders:byBundle"
              yes={() => (
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <RonadIcons name='key'
                        className={classes.icon}
                      />
                      {`شناسه بسته :  `}
                    </span>
                    <Link to={`/bundles/${props.order.bundleId}`}>
                      <span data-cy="bundleId">{props.order.bundleId}</span>
                    </Link>
                  </div>
                </Grid>
              )}
            />
          )}
          <Grid item xs={12} sm={6}>
            <div className={classes.item}>
              <span className={classes.label}>
                <RonadIcons name='mapMarker' className={classes.icon}/>
                {` نام مرکز:  `}
              </span>
              <span data-cy="centerName">{props.order.centerName}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container>
        <Grid item xs={12}>
          <Timeline align="left">
            {props.logs
              ?.slice()
              .reverse()
              .map((log: Log, index: number) => (
                <TimelineItem
                  className={classes.missingOppositeContent}
                  key={index}
                  data-cy="timeLineItem"
                >
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        backgroundColor: colorStatus[log.newStatus],
                        borderColor:
                          index === 0 ? theme.palette.secondary.main : '',
                      }}
                    >
                      <RonadIcons name={iconStatus[log.newStatus]} size={1} className='text-white'/>
                    </TimelineDot>
                    {index !== props.logs?.length - 1 ? (
                      <TimelineConnector />
                    ) : (
                      ''
                    )}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paperHistory}>
                      <Typography component="div" className={classes.titleBox}>
                        {log.time &&
                          jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                      <div className={classes.contentBox}>
                        <div>
                          <span className={classes.contentlabel}>
                            وضعیت سفارش:
                          </span>
                          <span data-cy="logStatus">
                            {translate(log.newStatus, 'order')}
                          </span>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>کاربر:</span>
                          <Can
                            role={authContext.user.role}
                            perform="user-name:dontShowInLogs"
                            no={() => (
                              <>
                                <span data-cy="modifierName">
                                  {log.modifierName}
                                </span>
                                <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                              </>
                            )}
                          />
                          <span>{translate(log.modifierRole, 'user')}</span>
                        </div>
                        {log.description && (
                          <div style={{ marginTop: '12px' }}>
                            <span className={classes.contentlabel}>
                              توضیحات:
                            </span>
                            <span data-cy="description">{log.description}</span>
                          </div>
                        )}
                      </div>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))}
          </Timeline>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  order: makeSelectOrder(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Logs);
